import { h, render, Component } from 'preact';
import { classNames, checkRequiredInvalid, checkCreditCard, checkZip, formatNumber } from '../utils/utils';
import { appConfig } from '../app.config';
import axios from 'axios';
import TxrInput from './txr-input';
import TxrPasswordInput from './txr-password-input';
import TxrDropdown from './txr-dropdown';
import TxrCheckbox from './txr-checkbox';
import { PlanService } from '../plan-service.service';

class TxrPurchaseForm extends Component {
    state = {

        discount: 0,
        discountIsLoading: false,
        salesTax: 0,
        invalid: false,
        isSubmitted: false,
        hipaa: {},
        years: [],
        errors: {
            required: 'Required field',
            phone: 'The phone number you supplied must be in a ten or eleven digit format.',
            password: 'The password requirements are not met',
            repassword: 'Password does not match',
            discount: 'Error during requesting discount',
            unknowndiscount: 'Unknown discount code',
            discountnotvalid: 'This code isn\'t valid for your selected plan.',
            zip: 'US or Canadian postal code required',
            card: 'Invalid card number'
        },
        agree: {
            isChecked: false
        },
        passwordModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                const hasError = checkRequiredInvalid(model, this.state.isSubmitted) || model.checkPassword(model, this.state.isSubmitted);
                model.invalid = hasError && this.state.isSubmitted;
                this.state.invalid = this.state.invalid || model.invalid;
                this.forceUpdate();
            },
            checkPassword: (model, isSubmitted) => {
                let password = model.value;
                model.pwdMinCharacters = password.length >= 8 && /[A-Za-z]/ig.test(password);
                model.pwdNumber = /[0-9]/ig.test(password);
                model.pwdSymbol = /[^\w]|\*|\_/.test(password);
                let hasError = isSubmitted && (!model.pwdMinCharacters || !model.pwdNumber || !model .pwdSymbol);
                model.errors['password'] = hasError;
                return hasError;
            }
        },
        rePasswordModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                const hasError = checkRequiredInvalid(model, this.state.isSubmitted) || model.checkRePassword(model, this.state.isSubmitted);
                model.invalid = hasError && this.state.isSubmitted;
                this.state.invalid = this.state.invalid || model.invalid;
                this.forceUpdate();
            },
            checkRePassword: (model, isSubmitted) => {
                let hasError = isSubmitted && this.state.passwordModel.value !== model.value;
                model.errors['repassword'] = hasError;
                return hasError;
            }
        },
        cardNumberModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                model.cardNumber = model.value ? model.value.replaceAll(/\s/g, '') : '';
                const hasError = checkRequiredInvalid(model, this.state.isSubmitted) || checkCreditCard(model, this.state.isSubmitted);
                model.invalid = hasError && this.state.isSubmitted;
                this.forceUpdate();
            }
        },
        expMonthModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                const hasError = checkRequiredInvalid(model, this.state.isSubmitted);
                model.invalid = hasError && this.state.isSubmitted;
                this.forceUpdate();
            }
        },
        expYearModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                const hasError = checkRequiredInvalid(model, this.state.isSubmitted);
                model.invalid = hasError && this.state.isSubmitted;
                this.forceUpdate();
            }
        },
        cvvCodeModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                const hasError = checkRequiredInvalid(model, this.state.isSubmitted);
                model.invalid = hasError && this.state.isSubmitted;
                this.forceUpdate();
            }
        },
        zipCodeModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                model.cardNumber = model.value ? model.value.replaceAll(/\s/g, '') : '';
                const hasError = checkRequiredInvalid(model, this.state.isSubmitted) || checkZip(model, this.state.isSubmitted);
                model.invalid = hasError && this.state.isSubmitted;
                this.forceUpdate();
            },
            onBlur: (model) => {
                this.loadSalesTax();
            }
        },
        nameCardModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                const hasError = checkRequiredInvalid(model, this.state.isSubmitted);
                model.invalid = hasError && this.state.isSubmitted;
                this.forceUpdate();
            }
        },
        discountCodeModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                this.discountCode = model.value;
                if (this.discountTimer) {
                    clearTimeout(this.discountTimer);
                }
                if (!model.value) {
                    model.invalid = false;
                    model.errors['discount'] = false;
                    model.errors['unknowndiscount'] = false;
                    model.errors['discountnotvalid'] = false;
                    this.setState({ discountIsLoading: false, discount: 0 });
                    this.forceUpdate();
                    return;
                } 
                this.discountTimer = setTimeout(() => {
                    this.discountTimer = null;
                    this.loadDiscount(model);
                }, 1000);
                this.forceUpdate();
            }
        }
    }


    isInvalid() {
        return this.state.passwordModel.invalid ||
        this.state.rePasswordModel.invalid ||
        this.state.cardNumberModel.invalid ||
        this.state.expMonthModel.invalid ||
        this.state.expYearModel.invalid ||
        this.state.cvvCodeModel.invalid ||
        this.state.zipCodeModel.invalid ||
        this.state.nameCardModel.invalid ||
        !this.state.agree.isChecked;
    }

    getDiscountCodeForRequests() {
        const raw = this.state.discountCodeModel.value.trim() || '';
        if (!raw || this.state.discountCodeModel.invalid) {
            return '';
        }
        return raw;
    }

    loadDiscount(model) {
        this.setState({ discountIsLoading: true });
        const url = appConfig.url + '/webservices/discountcode?code=' + encodeURIComponent(model.value) + '&planId=' + this.props.plan.id;
        const options = {
            method: 'GET',
            headers: { 'content-type': 'application/json; charset=utf-8' },
            url,
        };
        axios(options)
        .then((response) => {
            const pct = response.data ? response.data.percentMonthlyDiscount : null;
            if (pct == null) {
                this.setState({ discountIsLoading: false, discount: 0 });
                this.state.discountCodeModel.invalid = true;
                this.state.discountCodeModel.errors['unknowndiscount'] = true;
                this.state.discountCodeModel.errors['discountnotvalid'] = false;
                this.state.discountCodeModel.errors['discount'] = false;
                this.forceUpdate();
                this.loadSalesTax();
                return;
            }
            this.setState({ discountIsLoading: false, discount: pct });
            this.state.discountCodeModel.invalid = false;
            this.state.discountCodeModel.errors['unknowndiscount'] = false;
            this.state.discountCodeModel.errors['discountnotvalid'] = false;
            this.state.discountCodeModel.errors['discount'] = false;
            this.forceUpdate();
            this.loadSalesTax();
        })
       .catch((error) => {
            let data = error.response && error.response.data;
            if (typeof data === 'string') {
                // the endpoint returns error bodies as a JSON string; other bodies are used as-is
                try {
                    data = JSON.parse(data);
                } catch (e) {}
            }
            const rawMsg = data && typeof data === 'object'
                ? (data.message || data.Message || data.detail || data.Detail || data.errorMessage || data.title)
                : (typeof data === 'string' ? data : '');
            const msg = typeof rawMsg === 'string' ? rawMsg.replace(/\u2019/g, "'").trim() : '';
            const planMsg = typeof this.state.errors.discountnotvalid === 'string'
                ? this.state.errors.discountnotvalid.replace(/\u2019/g, "'").trim()
                : '';
            this.setState({ discountIsLoading: false, discount: 0 });
            this.state.discountCodeModel.invalid = true;
            this.state.discountCodeModel.errors['unknowndiscount'] = false;
            this.state.discountCodeModel.errors['discountnotvalid'] = false;
            this.state.discountCodeModel.errors['discount'] = false;
            if (!error.response) {
                this.state.discountCodeModel.errors['discount'] = true;
            } else if (msg && msg === planMsg) {
                this.state.discountCodeModel.errors['discountnotvalid'] = true;
            } else {
                this.state.discountCodeModel.errors['unknowndiscount'] = true;
            }
            this.forceUpdate();
            this.loadSalesTax();
        });
    }

    loadSalesTax() {
        if(!this.state.zipCodeModel.value ||this.state.zipCodeModel.invalid) {
            return;
        }
        let url = appConfig.url + '/webservices/account/purchase/taxamount?planId=' + this.props.plan.id + '&zipCode=' + this.state.zipCodeModel.value;
        const discountCodeForTax = this.getDiscountCodeForRequests();
        if (discountCodeForTax) {
            url = url + '&discountCode=' + encodeURIComponent(discountCodeForTax);
        }
        const options = {
            method: 'GET',
            headers: { 'content-type': 'application/json; charset=utf-8' },
            url,
        };
        axios(options)
        .then((response) => {
            if(response && response.data != undefined) {
                this.setState({ salesTax: response.data });
            }
        })
       .catch(() => {
            this.setState({ salesTax: 0 });
        });
    }

    getFeaturesArray() {
        let res = [];
        this.props.features.forEach((f) => {
            if (f.isChecked) {
                res.push(f.id);
            }
        });
        if(this.props.isHipaa) {
            res.push(this.state.hipaa.featureId);
        }
        return res;
    }
    componentDidMount() {
       this.planService = new PlanService();
       this.state.hipaa = this.planService.getHipaaDescription();
       let year = new Date().getFullYear();
       for(let i = 0; i <= 10; i++) {
          let y=year + i; 
          this.state.years.push ({id: y, title: y });
       }
    }

    getDiscount() {
        if (!this.state.discount) {
            return 0;
        }
        if (!this.props.plan) {
            return 0;
        }
        let val = this.props.plan.price * this.state.discount / 100;
        return val;
    }

    getCost() {
        let sum = 0;
        this.props.features.forEach((f) => {
            sum = sum + f.cost;
        });
        if(this.props.isHipaa) {
            sum = sum + this.state.hipaa.cost;
        }
        return this.props.plan.price - this.getDiscount() + sum;
    }

    getCharge() {
        return this.props.plan.price - this.getDiscount() + this.state.salesTax;
    }

    checkAgree() {
        this.forceUpdate();
        // this.test();
    }

    test() {

          const purchaseEventData = {
                    'event': 'purchase', 
                    'event_category': 'ecommerce', 
                    'purchase_plan_type': 'test', 
                    'total_purchase': 11,
                    'purchased_features': this.getFeaturesArray(), 
                };
                gtag('event', 'purchase', purchaseEventData);
    }
  

    purchase() {
        this.state.isSubmitted = true;
        this.setState({ isSubmitted: true });

        this.state.invalid = false
        this.state.passwordModel.change(this.state.passwordModel);
        this.state.rePasswordModel.change(this.state.rePasswordModel);
        this.state.cardNumberModel.change(this.state.cardNumberModel);
        this.state.expMonthModel.change(this.state.expMonthModel);
        this.state.expYearModel.change(this.state.expYearModel);
        this.state.cvvCodeModel.change(this.state.cvvCodeModel);
        this.state.zipCodeModel.change(this.state.zipCodeModel);
        this.state.nameCardModel.change(this.state.nameCardModel);

        if(this.isInvalid()) {
            return;
        }

        grecaptcha.execute('6LfIJ-oUAAAAAEMV2HwqxT3fKvO1RxVa47bHXG3f', {action: 'purchase'}).then((token) => {

            dataLayer.push({ ecommerce: null });
        
            let referralPartnerId = null;
            try {
                const referralPartnerInfoStr = localStorage.getItem(appConfig.referralPartnerIdKey); 
                if(referralPartnerInfoStr) {
                    const referralPartnerInfo = JSON.parse(referralPartnerInfoStr);
                    const date = new Date(referralPartnerInfo.date);
                    console.log(date);
                    const diffTime = Math.abs(new Date() - date);
                    console.log(diffTime);
                    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
                    console.log(diffDays);
                    if(diffDays <= 30 && referralPartnerInfo.referralPartnerId) {
                        referralPartnerId = referralPartnerInfo.referralPartnerId;
                    }
                }
            }
            catch(e) {
                referralPartnerId = null;
            }
            /*
            var partnerStackPartnerKey = null;
            try {
                growsumo.data.name = localRefs.txrForm.companyModel.value;
                growsumo.data.email = localRefs.txrForm.emailModel.value;
                partnerStackPartnerKey = growsumo.data.partner_key;
            } catch (e) {
                // Errors here should not interrupt purchase process
                partnerStackPartnerKey = null;
            }
            */
            const appliedDiscountCode = this.getDiscountCodeForRequests();
            const data =
            {
                prepurchaseId: this.props.prepurchaseId, 
                firstName: this.props.accountInfo.firstName,
                lastName: this.props.accountInfo.lastName,
                company: this.props.accountInfo.company,
                phone: this.props.accountInfo.phone,
                email: this.props.accountInfo.email,
                password: this.state.passwordModel.value,
                cardNumber: this.state.cardNumberModel.cardNumber,
                cardExpirationMonth: this.state.expMonthModel.value.id,
                cardExpirationYear: this.state.expYearModel.value.id,
                cvvCode: this.state.cvvCodeModel.value,
                billingZipCode: this.state.zipCodeModel.value,
                nameOnCard: this.state.nameCardModel.value,
                planId: this.props.plan.id,
                discountCode: appliedDiscountCode,
                addOnFeatures: this.getFeaturesArray(),
                recaptchaToken: token,
                referralPartnerId: referralPartnerId,
                //partnerStackPartnerKey: partnerStackPartnerKey,
                isHipaa: this.props.isHipaa
            };

            this.setState({ isLoading: true });
            const url = appConfig.url + '/webservices/account/purchase';
            const options = {
                method: 'POST',
                headers: { 'content-type': 'application/json; charset=utf-8' },
                data: JSON.stringify(data),
                url,
            };
            axios(options)
            .then((res) => {
                const response = res.data;
                this.setState({ isLoading: false });
                window.dataLayer = window.dataLayer || [];
                const ecommerceData = {
                            'transactionId': response.purchaseInvoiceId,                
                            'transactionAffiliation': 'website',
                            'transactionTotal': response.planPurchasePrice,              
                            'transactionProducts': [{                            
                                'name': response.planName,     
                                'sku': response.planId,
                                'price': response.planPurchasePrice,
                                'category': 'plan',
                                'quantity': 1
                            }]
                        };
                       
        
                response.addedFeatures.forEach(function(feature) {
                    ecommerceData.transactionProducts.push({
                        'name': feature.featureName,     
                        'sku': feature.id,
                        'price': feature.featureCost,
                        'category': 'feature',
                        'quantity': 1
                    });
                });
        
                const purchaseEventData = {
                    'event': 'purchase', 
                    'event_category': 'ecommerce', 
                    'purchase_plan_type': response.planName, 
                    'total_purchase': response.planPurchasePrice,
                    'purchased_features': this.getFeaturesArray(), 
                    'transactionId': ecommerceData.transactionId,
                    'transactionAffiliation': ecommerceData.transactionAffiliation,
                    'transactionTotal': ecommerceData.transactionTotal,
                    'transactionProducts': ecommerceData.transactionProducts
                };
                //window.dataLayer.push(purchaseEventData);
                gtag('event', 'purchase', purchaseEventData);
                const tokenData = {
                    access_token: response.access_token,
                    refresh_token: response.refresh_token,
                    refresh_token_expires_in: response.refresh_token_expires_in,
                    expires_in: response.expires_in,
                    username: this.props.accountInfo.email
                };
                try {

                    window.lintrk('track', { conversion_id: this.props.plan.linkedInConversionId });
                    this.props.plan.id
                } catch(e) {
                    console.error(e);
                }
                this.props.onPurchase(tokenData);
            })
            .catch((e) => {
                this.setState({ isLoading: false });
                let purchaseErrorTitle = null;
                let purchaseErrorMessage = null;
                if(e.response && e.response.status=== 400 && e.response.data) {
                    if(e.response.data.errorMessage === 'INVALID_CARD_NUMBER') {
                        purchaseErrorTitle = 'Invalid Credit Card Number';
                        purchaseErrorMessage = 'That appears to be an invalid credit card number. Please re-enter your card details to try again.';
                       
                    } else
                    if(e.response.data.errorMessage === 'CARD_DECLINED') {
                            purchaseErrorTitle = 'Cannot Process This Card';
                            purchaseErrorMessage = 'This card could not be processed. Contact your issuing bank for details. Please try another card.';
                    } else {
                        purchaseErrorTitle = 'Operation Failed';
                        purchaseErrorMessage = e.response && e.response.data ? e.response.data.errorMessage: 'Generic Error';
                    }
                }
                if(!purchaseErrorMessage ) {
                    purchaseErrorTitle = 'Operation Failed';
                    purchaseErrorMessage = e.response && e.response.data ? e.response.data.errorMessage: 'Generic Error';
                }
                this.setState({ purchaseErrorTitle: purchaseErrorTitle, purchaseErrorMessage: purchaseErrorMessage });
            });
        });
        /*
        this.setState({ isLoading: true });
        setTimeout(() => {
            this.setState({ isLoading: false });
            //this.setState({ errorMessage: 'You already have a Text Request account. If you want to purchase a new account, please use a different email address.' });
            this.props.onPurchase();
        }, 1000);
        */
        
    }
    onSubmit = e => {
        return false;
      }

    render() {
        return (
            <div class="txr-purchase-form">
                <div class="purchase-form__left">
                    <h2 class="purchase-form__header">Your plan selection</h2>
                    <div class="purchase-form__panel">
                        <div class="plan-desc__header">
                            <div class="header__title">{this.props.plan.name} <br />Plan</div>
                            <div class="header__price">${formatNumber(this.props.plan.price)}<span class="header__price-hint">/ mo</span></div>
                        </div>
                        {
                            (this.props.isHipaa || (this.props.features && this.props.features.map && this.props.features.length > 0)) && 
                            <div class="plan-desc__features">
                                {
                                    this.props.isHipaa &&
                                    <div class="feature-item">
                                        <div class="feature-item__name">HIPAA Compliance</div>
                                        <div class="feature-item__price">${this.state.hipaa.cost}/mo</div>
                                    </div>
                                }
                                {
                                    this.props.features && this.props.features.map && this.props.features.map(feature =>
                                        <div class="feature-item">
                                            <div class="feature-item__name">{feature.name}{feature.nameHint}</div>
                                            <div class="feature-item__price">${feature.cost}/mo</div>
                                        </div>
                                    )
                                }
                            </div>
                        }
                        <div class="plan-desc__monthly txr-mt30">
                            <div class="item__name">Monthly Base Cost</div>
                            <div class="item__price">${formatNumber(this.getCost())}/mo</div>
                        </div>
                        { this.state.salesTax > 0 &&
                            <div class="plan-desc__monthly txr-mt10">
                                <div class="item__name">Sales Tax</div>
                                <div class="item__price">${formatNumber(this.state.salesTax)}</div>
                            </div>
                        }
                        <div class="plan-desc__total txr-mt30">
                            <div class="item__name">Today’s Charge</div>
                            <div class="item__price">${formatNumber(this.getCharge())}</div>
                        </div>
                        {this.props.features && this.props.features.length > 0 &&
                            <div class="plan-desc__hint">
                                Add-on features will be billed on your next invoice.
                            </div>
                        }
                    </div>
                </div>
                <div class="purchase-form__right">
                    <form onsubmit={this.onSubmit} class="purchase__form">
                        <h2 class="purchase-form__header">Select your password</h2>
                        <div class="form__item password">
                            <TxrPasswordInput model={this.state.passwordModel} label="Password" errors={this.state.errors}></TxrPasswordInput>
                        </div>
                        <div class="form__item">
                            <TxrInput model={this.state.rePasswordModel} label="Re-enter password" errors={this.state.errors} type={'password'}></TxrInput>
                        </div>
                        <h2 class="purchase-form__header payment-header">Payment Information</h2>
                        <div class="form__item">
                            <TxrInput model={this.state.cardNumberModel} autocomplete="cc-number" label="Card Number" errors={this.state.errors} type={'number'}></TxrInput>
                        </div>
                        <div class="form__item txr-50 txr-mr20 txr-mb20">
                            <TxrDropdown model={this.state.expMonthModel} label="Exp. month" options={[
                            {id: 1, title: 'January'},
                            {id: 2, title: 'February'},
                            {id: 3, title: 'March'},
                            {id: 4, title: 'April'},
                            {id: 5, title: 'May'},
                            {id: 6, title: 'June'},
                            {id: 7, title: 'July'},
                            {id: 8, title: 'August'},
                            {id: 9, title: 'September'},
                            {id: 10, title: 'October'},
                            {id: 11, title: 'November'},
                            {id: 12, title: 'December'}
                            ]}></TxrDropdown>
                        </div>
                        <div class="form__item txr-50 txr-ml20 txr-mb20">
                            <TxrDropdown model={this.state.expYearModel} label="Exp. year" options={this.state.years}></TxrDropdown>
                        </div>
                        <div class="form__item txr-50 txr-mr20">
                            <TxrInput model={this.state.cvvCodeModel} autocomplete="cc-csc" label="CVV code" errors={this.state.errors} type={'number'}></TxrInput>
                        </div>
                        <div class="form__item txr-50 txr-ml20">
                            <TxrInput model={this.state.zipCodeModel} autocomplete="postal-code" label="Billing zip code" errors={this.state.errors}></TxrInput>
                        </div>
                        <div class="form__item">
                            <TxrInput model={this.state.nameCardModel} autocomplete="cc-name" label="Name on card" errors={this.state.errors} ></TxrInput>
                        </div>
                        <div class="form__item">
                            <TxrInput model={this.state.discountCodeModel} label="Referral Code" errors={this.state.errors} loading={this.state.discountIsLoading}></TxrInput>  
                        </div>
                        <div class="form__item checkbox">
                            <div class="checkbox-item">
                            <TxrCheckbox item={this.state.agree} select={() => this.checkAgree()}></TxrCheckbox>I agree to the&nbsp;<a target="_blank" href="/terms-of-service" class="txr-text__link">terms and conditions</a>
                            &nbsp;and&nbsp;<a target="_blank" href="/privacy-policy " class="txr-text__link">privacy policy</a>
                            </div>
                            { this.state.isSubmitted && !this.state.agree.isChecked && 
                            <div class="txr-input__errors">
                                You must agree to the terms and conditions and privacy policy.
                            </div>
                            }
                        </div>
                        
                        <div class="purchase-form__button txr-mt20">
                            <button class="txr-button txr-primary-button" disabled={this.state.isLoading || (this.isInvalid() && this.state.isSubmitted)} type="button" onClick={() => this.purchase()}>
                                <span class="txr-button__content"> PURCHASE NOW
                                    {!this.state.isLoading && <i class="txr-button__angle-icon fal fa-angle-right"></i>}
                                    {this.state.isLoading && <i class="txr-button__spin-icon fas fa-circle-notch fa-spin"></i>}
                                </span>
                            </button>
                        </div> 
                    </form>
                    { this.state.purchaseErrorMessage &&
                        <div class="form__error">
                            <div class="form-error__title">{ this.state.purchaseErrorTitle }</div>
                            <div class="form-error__text">{ this.state.purchaseErrorMessage }</div>
                        </div>
                    } 

                </div>
            </div>
        )
    }
}
export default TxrPurchaseForm;